<template>
    <div class="g-text-center g-flexbox tabbar">
        <div
            @click="go('/')"
            :class="{
                on: currentPath === '/'
            }"
            class="g-flex tab">
            推荐
        </div>
        <div
            @click="go('/following', true)"
            :class="{
                on: currentPath === '/following'
            }"
            class="g-flex tab">
            关注
        </div>
        <div
            @click="go('/rankboard')"
            :class="{
                on: currentPath === '/rankboard'
            }"
            class="g-flex tab">
            热榜
        </div>
        <div
            @click="go('/home', true)"
            :class="{
                on: currentPath === '/home'
            }"
            class="g-flex tab">
            我
        </div>
        <auth-modal ref="authModal" />
    </div>
</template>

<script>
import authModal from './auth-modal.vue';
import parseCookie from '../utils/parseCookie';

export default {
    data() {
        return {
            currentPath: '',
            attemptPath: '',
        };
    },
    created() {
        this.currentPath = this.$router.history.current.fullPath;
    },
    watch: {
        $route(to) {
            this.currentPath = to.fullPath;
        },
    },
    components: {
        authModal,
    },
    methods: {
        go(path, needAuth = false) {
            if (needAuth && !this.validateAuth()) {
                this.attemptPath = path;
                this.openAuth();
                return;
            }
            this.$router.push(path);
        },
        validateAuth() {
            const { USER_TOKEN, USER_UID } = parseCookie(document.cookie);
            if (USER_TOKEN && USER_UID) {
                return true;
            }
            return false;
        },
        openAuth() {
            this.$refs.authModal.show()
                .then(() => {
                    this.$router.push(this.attemptPath);
                });
        },
    },
};
</script>

<style lang="scss">
    .tabbar {
        height: 0.5rem;
        position: fixed;
        z-index: 1;
        bottom: 0;
        width: 100%;
        font-weight: 800;
        background: rgba($color: #000000, $alpha: .2);

        .tab {
            line-height: .5rem;
            font-size: 0.16rem;
            text-decoration: none;
            user-select: none;
            color: #bbbbbb;

            &.on {
                color: #ffffff;
                font-size: 0.2rem;
            }
        }
    }
</style>
